var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSinglePlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.625 7.59286C12.5518 7.59286 13.4407 7.19288 14.0961 6.48091C14.7515 5.76895 15.1197 4.80331 15.1197 3.79643C15.1197 2.78956 14.7515 1.82392 14.0961 1.11195C13.4407 0.39998 12.5518 0 11.625 0C10.6982 0 9.80927 0.39998 9.15389 1.11195C8.49851 1.82392 8.13032 2.78956 8.13032 3.79643C8.13032 4.80331 8.49851 5.76895 9.15389 6.48091C9.80927 7.19288 10.6982 7.59286 11.625 7.59286ZM11.625 9.26084C6.9786 9.26084 4 12.0463 4 13.4025V15.935H19.25V13.4025C19.25 11.7624 16.4301 9.26084 11.625 9.26084Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6477 17.1818V23H11.9432V17.9205H11.9091L10.4886 18.8636V18.1477L11.9432 17.1818H12.6477Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePlayer);
export default __webpack_public_path__ + "static/media/single-player.b8d38f4fbf954be59fa37f0b32d1a68a.svg";
export { ForwardRef as ReactComponent };